
function WorkPlaceIcon() {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_4027_4009)">
				<path
					d="M6.875 4.375V0.625H13.125V4.375"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M8.125 11.875H0.625V5.625C0.625 5.29348 0.756696 4.97554 0.991117 4.74112C1.22554 4.5067 1.54348 4.375 1.875 4.375H18.125C18.4565 4.375 18.7745 4.5067 19.0089 4.74112C19.2433 4.97554 19.375 5.29348 19.375 5.625V11.875H11.875"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.125 14.375V16.875C18.125 17.2065 17.9933 17.5245 17.7589 17.7589C17.5245 17.9933 17.2065 18.125 16.875 18.125H3.125C2.79348 18.125 2.47554 17.9933 2.24112 17.7589C2.0067 17.5245 1.875 17.2065 1.875 16.875V14.375"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M11.875 9.375H8.125V14.375H11.875V9.375Z"
					stroke="white"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4027_4009">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default WorkPlaceIcon;
